import React, { useContext, useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg"
import { UserDetails } from 'appContext';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { regex } from 'views/pages/manage/common/constant';
import { addEditBankDetails, bankAccountTypes, studentRelationDropdown, userTypes } from "../../../../../edpOps/studentDetails/paymentSummary/studentBankDetails/utils"
import ALoader from 'views/pages/manage/common/a-loader';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ScanChequeCta from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/ScanChequeCta';
import styles from "views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/styles.module.scss";

const AddEditBankAccountDialog = ({
    dialogInfo,
    setDialogInfo,
    dropdownData = {},
}) => {
    const { isOpen, forEdit, initialForm = {}, viewOnly = false } = dialogInfo;
    const [accountDetailsForm, setAccountDetailsForm] = useState({});
    const { allCountries, allBanks } = dropdownData;

    useEffect(() => {
        if (!isOpen) return;

        setAccountDetailsForm(initialForm || {});
    }, [isOpen, initialForm?.id]);

    const closeDialog = () => setDialogInfo({});

    const formHandler = (key, value) => {
        setAccountDetailsForm(prev => ({ ...prev, [key]: value }))
    }

    const dialogHeading = viewOnly ? 'Bank account' : forEdit ? 'Edit bank account' : 'Add a new bank account';

    return (
        <Dialog
            open={!!isOpen}
            maxWidth={"md"}
            fullWidth
        >
            <div className={`${styles['dialog-container']}`}>

                <div className='d-flex justify-content-between'>
                    <div className={`${styles['dialog-heading']}`}>{dialogHeading}</div>
                    <div className='d-flex'>
                        {/* <ScanChequeCta /> */}
                        <CrossIcon className='ml-2' onClick={closeDialog} />
                    </div>
                </div>

                <div className={`${styles['form']}`}>
                    <AAutoComplete
                        label='Bank*'
                        currentValue={accountDetailsForm?.bankName}
                        handleChange={(val) => {
                            formHandler("bankName", val);
                        }}
                        items={allBanks}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />

                    <AAutoComplete
                        isDisabled
                        label='Country*'
                        currentValue={accountDetailsForm?.country}
                        items={allCountries}
                        isMulti={false}
                    />

                    <div>
                        <AInput
                            label="Account Number*"
                            placeholder="Enter"
                            value={accountDetailsForm?.bankAccount}
                            handler={(val) => {
                                formHandler("bankAccount", val);
                            }}
                            regex={regex.numeric}
                            maxLength={18}
                            disabled={viewOnly}
                        />
                    </div>

                    <AAutoComplete
                        label='Account Type*'
                        currentValue={accountDetailsForm?.accountType}
                        handleChange={(val) => {
                            formHandler("accountType", val);
                        }}
                        items={bankAccountTypes}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />


                    <div>
                        <AInput
                            label="IFSC Code*"
                            placeholder="Enter"
                            value={accountDetailsForm?.ifsc}
                            handler={(val) => {
                                formHandler("ifsc", val?.toUpperCase());
                            }}
                            regex={regex.alphaNumeric}
                            maxLength={11}
                            disabled={viewOnly}
                        />
                    </div>

                    <div>
                        <AInput
                            label="Name on Account*"
                            placeholder="Enter"
                            value={accountDetailsForm?.accountHolderName}
                            handler={(val) => {
                                formHandler("accountHolderName", val);
                            }}
                            regex={regex.alphabetsWithSpace}
                            disabled={viewOnly}
                        />
                    </div>

                    <div>
                        <AInput
                            label="Beneficiary Branch*"
                            placeholder="Enter"
                            value={accountDetailsForm?.bankBranch}
                            handler={(val) => {
                                formHandler("beneficiaryBranch", val);
                            }}
                            regex={regex.alphaNumericWithSpaceAndUnderscore}
                            disabled={viewOnly}
                        />
                    </div>

                </div>

            </div>

        </Dialog>
    )
}

export default AddEditBankAccountDialog